import { useState } from 'react';
import { PaginationInput } from 'modules/graphql';

type Offset = PaginationInput['offset'];

export const useOffsetState = (incrementAmount: Offset): [Offset, () => void] => {
  const [offset, update] = useState<Offset>(0);
  const setOffset = () => update((prev) => prev + incrementAmount);
  return [offset, setOffset];
};
